import { render, staticRenderFns } from "./FeeRanges.vue?vue&type=template&id=2095c012&scoped=true"
import script from "./FeeRanges.vue?vue&type=script&lang=ts"
export * from "./FeeRanges.vue?vue&type=script&lang=ts"
import style0 from "./FeeRanges.vue?vue&type=style&index=0&id=2095c012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095c012",
  null
  
)

export default component.exports